import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Breadcrumb, Card, Descriptions, Table, Tag, message } from "antd";
import type { ColumnsType } from "antd/es/table";
import { api, type SensorDetailResp, type SensorInterface } from "../api";

export default function SensorDetail() {
  const { id } = useParams<{ id: string }>();
  const [data, setData] = useState<SensorDetailResp | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) return;
    (async () => {
      try {
        setData(await api.sensor(Number(id)));
      } catch (e) {
        message.error(String(e));
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  const columns: ColumnsType<SensorInterface> = [
    { title: "if_index", dataIndex: "if_index", width: 120 },
    { title: "Name", dataIndex: "name" },
    {
      title: "Direction",
      dataIndex: "direction",
      width: 140,
      render: (v: string) => <Tag color={v === "in" ? "blue" : "orange"}>{v}</Tag>,
    },
    {
      title: "Color",
      dataIndex: "color",
      width: 140,
      render: (v: string) =>
        v ? (
          <span>
            <span
              style={{
                display: "inline-block",
                width: 12,
                height: 12,
                background: v,
                marginRight: 8,
                borderRadius: 2,
                verticalAlign: "middle",
              }}
            />
            {v}
          </span>
        ) : (
          "—"
        ),
    },
  ];

  return (
    <>
      <Breadcrumb
        style={{ marginBottom: 16 }}
        items={[{ title: <Link to="/">Dashboard</Link> }, { title: `Sensor ${id}` }]}
      />
      <Card title="Sensor" loading={loading} style={{ marginBottom: 16 }}>
        {data && (
          <Descriptions column={3} bordered size="small">
            <Descriptions.Item label="ID">{data.sensor.id}</Descriptions.Item>
            <Descriptions.Item label="Name">{data.sensor.name}</Descriptions.Item>
            <Descriptions.Item label="Enabled">
              {data.sensor.enabled ? "yes" : "no"}
            </Descriptions.Item>
            <Descriptions.Item label="Protocol">{data.sensor.protocol}</Descriptions.Item>
            <Descriptions.Item label="Listen port">{data.sensor.listen_port}</Descriptions.Item>
            <Descriptions.Item label="Zone ID">{data.sensor.zone_id}</Descriptions.Item>
          </Descriptions>
        )}
      </Card>
      <Card title="Interfaces">
        <Table
          rowKey="if_index"
          loading={loading}
          dataSource={data?.interfaces ?? []}
          columns={columns}
          pagination={false}
          size="middle"
        />
      </Card>
    </>
  );
}
